import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "../api/client";
import type { CRMUser, WorkspaceProduct } from "../api/types";

export function useBusinessKnowledgeAvailability(user: CRMUser, workspaceProduct: WorkspaceProduct | null = null) {
  return useQuery({
    queryKey: ["business-knowledge-availability", user.tenant_id, user.id],
    queryFn: () => apiRequest<{ available: boolean }>("/api/business-knowledge/availability"),
    enabled: user.role === "owner" && workspaceProduct !== "SIMPLE_BILLING",
    retry: false,
    staleTime: 60000,
    refetchOnWindowFocus: false,
  });
}
